import { render } from "./PresentCreate.vue?vue&type=template&id=0d6c2ac8"
import script from "./PresentCreate.vue?vue&type=script&lang=js"
export * from "./PresentCreate.vue?vue&type=script&lang=js"

import exportComponent from "/usr/src/client/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__